import { InputField, SelectField } from '@shared/ui/organisms'

export const COMPONENTS_BY_NAME = {
  id1: InputField,
  region: InputField,
  zone: InputField,
  // новые
  email: InputField,
  uid: InputField,
  server: SelectField,
  uidPubg: InputField,
  id: InputField,
  zoneId: InputField,
  playerId: InputField,
}
